/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type MappingImage_products$ref: FragmentReference;
declare export opaque type MappingImage_products$fragmentType: MappingImage_products$ref;
export type MappingImage_products = $ReadOnlyArray<{|
  +id: string,
  +status: string,
  +mapping: ?{|
    +svgPath: string
  |},
  +$refType: MappingImage_products$ref,
|}>;
export type MappingImage_products$data = MappingImage_products;
export type MappingImage_products$key = $ReadOnlyArray<{
  +$data?: MappingImage_products$data,
  +$fragmentRefs: MappingImage_products$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "MappingImage_products",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DevelopmentMapping",
      "kind": "LinkedField",
      "name": "mapping",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "svgPath",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '4841d5db16830bd4b7b85676a254b9ef';

export default node;
